<template>
    <div class="product-1">
        <div class="News-wrap">
            <h3>专业游艇码头 制造商<br>Professional Floating Dock Manufacturer</h3>
        </div>

        <div class="navigation-wrap">

            <div class="navigation-bar">
                <div class="navigation-left-bar">
                    <p>您的位置：</p>
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/Case' }">产品</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </div>

        <div class="title-wrap">
            <div class="title">
                <h3>JET SKI DOCK/BOAT DOCK<br>摩托艇快艇码头</h3>
            </div>

            <div class="content-wrap">
                

                <p>摩托艇快艇码头：<br><br>
                    摩托艇/快艇码头全部由塑胶为原料制造，独特的干泊位设计，可以将摩托艇或其它船只直接开上码头。避免船只因长期停留在水中而产生污点、生锈、生长藻类、腐蚀等对船外壳的伤害。拥有一组摩托艇、快艇码头，不单可以减少对船只的损坏而且不用任何维护费用。安装拆卸方便、实用美观、自由组合，可以停放不同型号的的船只。摩托艇码头可以任意设计不同尺寸的走道，方便上下船只或者在码头上清洗、维修船只。<br><br>


                    JET SKI DOCK/BOAT DOCK<br><br>
                    When stored in the water, jet ski hulls can suffer from delamination and intake fouling. With our floating jet ski docks and boat dock, you'll save your craft from undue wear and tear and improve ease of use. 
Featuring an innovative design, you can add or reconfigure pontoons as you need. This floating dock allows you to drive on and off in seconds! Built with users in mind, Acrdock features ample walk-around space to make it easy for you to board, unboard, and launch your jet ski instantly. Made with high-density polyethylene materials, our floating pontoon are lightweight, durable, easy to install with simple cleats and connectors, and don’t require any special tools or technical skills.
<br><br>
                </p>
            </div>

            <div class="img-wrap">
                <img src="../assets/Product/3.jpg" alt="">
            </div>
            <div class="content-wrap">
                <h2>JET SKI DOCK/BOAT DOCK<br>
                    滑道快艇码头<br><br></h2>
            </div>
            <div class="img-wrap">
                <img src="../assets/Product/4.jpg" alt="">
            </div>
            <div class="content-wrap">
                <h2>JET SKI DOCK/BOAT DOCK<br>
                    V型浮筒快艇码头<br><br></h2>
            </div>
            <div class="img-wrap">
                <img src="../assets/Product/5.jpg" alt="">
            </div>
            <div class="content-wrap">
                <h2>JET SKI DOCK/BOAT DOCK<br>
                    滚轮浮筒快艇码头<br><br></h2>
            </div>


            <section class="gallery" id="gallery">
                <div class="box-container">

                    <div class="box" v-for="item in items" :key="item.id">
                        <img :src="item.img" alt="">
                        <!-- <span>2020.06 </span>
                    <h3>澳大利亚-Tom快艇码头</h3> -->
                    </div>

                </div>

            </section>

        </div>


    </div>
</template>

<script>
    export default {
        data() {
            return {
                items: [{
                        id: '01',
                        img: require('../assets/Case/Boat/2/1.jpg')
                    },
                    {
                        id: '02',
                        img: require('../assets/Case/Boat/2/2.jpg')
                    },
                    {
                        id: '03',
                        img: require('../assets/Case/Boat/2/3.jpg')
                    },
                    {
                        id: '04',
                        img: require('../assets/Case/Boat/2/6.jpg')
                    },
                    {
                        id: '05',
                        img: require('../assets/Case/Boat/2/4.jpg')
                    },
                    {
                        id: '06',
                        img: require('../assets/Case/Boat/2/5.jpg')
                    }

                ],
            }
        },
    }
</script>

<style src='../assets/css/Product.css'>

</style>